<template>
    <v-combobox
        v-model="addModel"
        :items="items"
        :search-input="search"
        hide-selected
        hide-details=""
        v-on:change="OnCategorySelected"
        v-on:focus="OnCategoryFocus"
        label="Add category"
        item-text="name"
        chips=""
        dense
        :filled="filled"
        >
        <template v-slot:no-data>
            <v-list-item>
            <v-list-item-content>
                <v-list-item-title v-if="isLoaded">
                No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                </v-list-item-title>
                <v-progress-circular style="pointer-events:none" indeterminate="" v-else></v-progress-circular>
            </v-list-item-content>
            </v-list-item>
        </template>
    </v-combobox>
</template>

<script>
import axios from 'axios'
import CONFIG from '../../appconfig.json'
import { GetAuthorisationHeaderGroup} from '../../vuex/assetxphelpers.js'

export default {
    name: "CategorySearch",
    props: {
        //Dialog attached to this category search
        attachedDialog :
        {
            default : null,
            type : Boolean
        },
        //Should this search use the fillted style
        filled : {
            default : false,
            type : Boolean
        },
        //Should this clear upon selection
        clearAfterSelect : {
            default : false,
            type : Boolean
        },
        sectionid : null
    },
    computed:{

    },
    data: () => ({

        items: [],
        addModel: "",
        search: "",
        isLoaded : false,

    }),
    methods:{

        OnCategorySelected(category) {

            if(this.addModel === Object(this.addModel))
            {
                this.$emit("CategorySelected",category);

              
                if(this.clearAfterSelect)
                {
                    this.$nextTick(() => {
                        this.addModel = "";
                        this.search = "";
                    })
                }
            }
            else
            {
                this.$nextTick(() => {
                    this.addModel = "";
                    this.search = "";
                })
            }
        },
        OnCategoryFocus()
        {
            if(!this.isLoaded)
            {
                if(this.sectionid != null)
                {
                    axios.get(CONFIG.platformEndpoints.assetxpapi +  'category/getallinsection/' + this.sectionid,GetAuthorisationHeaderGroup())
                    .then( (response) => {
                        this.items = response.data;
                        this.isLoaded = true;
                    })
                }
                else
                {
                    axios.get(CONFIG.platformEndpoints.assetxpapi +  'category/getall',GetAuthorisationHeaderGroup())
                    .then( (response) => {
                        this.items = response.data;
                        this.isLoaded = true;
                    })
                }
            }
        }
    },
    watch: {
        attachedDialog : {
            handler(newVal)
            {
                if(newVal)
                {
                    this.addModel = "";
                }
            }
        }
    }
}
</script> 

<style>

</style>